import { render, staticRenderFns } from "./StudentsEdit.vue?vue&type=template&id=bb3c6b00&scoped=true"
import script from "./StudentsEdit.vue?vue&type=script&lang=js"
export * from "./StudentsEdit.vue?vue&type=script&lang=js"
import style0 from "./StudentsEdit.vue?vue&type=style&index=0&id=bb3c6b00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3c6b00",
  null
  
)

export default component.exports